export default function getMRRChoices() {
  const K = 1000
  return [
    /* eslint no-multi-spaces: "off" */
    { value: 0, label: '0' },
    { value: 5 * K, label: '5K' },
    { value: 10 * K, label: '10K' },
    { value: 50 * K, label: '50K' },
    { value: 75 * K, label: '75K' },
    { value: 100 * K, label: '100K' },
    { value: 150 * K, label: '150K' },
    { value: 200 * K, label: '200K' },
    { value: 250 * K, label: '250K' },
    { value: Infinity, label: '500K+' },
  ]
}

export const monthlyRecurringRevenueChoices = getMRRChoices()
